<template>
    <v-container>
        <v-skeleton-loader v-if="! periods" type="list-item@3"></v-skeleton-loader>

        <v-list v-else elevation="1">
            <v-list-item
                v-for="period in periods"
                :key="period.id"
                :to="{ name: 'registration.user', params: { period_id: period.id } }"
            >
                <v-list-item-content>
                    <v-list-item-title>
                        {{ period.title }}

                        <template v-if="period.is_trial">
                            (Trial)
                        </template>
                    </v-list-item-title>
                </v-list-item-content>

                <v-list-item-icon>
                    <v-icon>mdi-chevron-right</v-icon>
                </v-list-item-icon>
            </v-list-item>
        </v-list>
    </v-container>
</template>

<script>
export default {
    data() {
        return {
            periods: null
        }
    },

    created() {
        this.$api.get('period')
            .then(response => {
                this.periods = response.data.periods
            })
    }
}
</script>
